import { Record } from 'immutable'
import { Address, IAddress } from './Address'
import { ListingType } from './enums'

export interface ISoldProperty {
  readonly address: IAddress
  readonly closingDate: number
  readonly contractDate: number
  readonly daysOnMarket: number
  readonly daysToClose: number
  readonly listingDate: number
  readonly listingId: string
  readonly listingType: ListingType
  readonly name: string
  readonly pipelineId: string
  readonly propertyId: string
  readonly salesPrice: number
}

const SoldPropertyRecord = Record({
  address: new Address(),
  closingDate: 0,
  contractDate: 0,
  daysOnMarket: 0,
  daysToClose: 0,
  listingDate: 0,
  listingId: '',
  listingType: ListingType.Sale,
  name: '',
  pipelineId: '',
  propertyId: '',
  salesPrice: 0,
})

export class SoldProperty extends SoldPropertyRecord implements ISoldProperty {
  public static fromJS(initialState?: Partial<ISoldProperty>) {
    if (!initialState) {
      return new SoldProperty()
    }

    const { address, ...rest } = initialState

    return new SoldProperty({
      address: Address.fromJS(address),
      ...rest,
    })
  }

  public readonly address: IAddress
  public readonly closingDate: number
  public readonly contractDate: number
  public readonly daysOnMarket: number
  public readonly daysToClose: number
  public readonly listingDate: number
  public readonly listingId: string
  public readonly listingType: ListingType
  public readonly name: string
  public readonly pipelineId: string
  public readonly propertyId: string
  public readonly salesPrice: number

  constructor(props?: Partial<SoldProperty>) {
    props ? super(props) : super()
  }
}
